import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useMeta() {
  const [indikators, setIndikators] = useState([]);
  const [tahuns, setTahuns] = useState([]);

  useEffect(() => {
    api.get("/indikator").then((r) => setIndikators(r.data)).catch(() => {});
    api.get("/options/tahun").then((r) => setTahuns(r.data)).catch(() => {});
  }, []);

  return { indikators, tahuns };
}
